SymbolToStringRegistry